// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4042":"2236cd05","9323":"f452bab3"}[chunkId] + ".chunk.css";
};